module.exports = __webpack_public_path__ + "static/img/ddjx.19703b04.png";